import { styled } from 'styled-components';

export const DisplayDataStyle = styled.section`
  min-height: 93vh;
`;
